import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUserIsLoggedIn } from '../../../store/componentStores/Account/account.selectors';
import { showLoyalty } from '../../../store/reducers';
import { Box, Flex, Text } from '../../ui-kit';
import theme from '../../ui-kit/themes/theme';
import { editCopyByReplaceWithMultipleComponent } from '../../utilities/copyFunctions';
import { LOYALTY_IMAGES } from '../assets/images';
import { Icon, LoyaltyGenericContainer, TextBoldWithNormal } from '../assets/styles';
import * as COPY from '../utilities/copy';

const LoyaltyAvailableMobileSearch = ({ amount, showLoyalty, isUserLoggedIn, isNewWidgetStyleActive }) => {
  const loggedUserCopy = {
    '<amount>': amount
  };

  return showLoyalty && isUserLoggedIn ? (
    <LoyaltyGenericContainer
      isNewWidgetStyleActive={isNewWidgetStyleActive}
      alignItems="center"
      maxWidth="100%"
      enableMobilePadding>
      <Icon src={LOYALTY_IMAGES.VOYAGER_ICON_FOREST_GREEN_WHITE} alt="Loyalty" size={'34px'} />
      <Box ml="12px" maxWidth={isNewWidgetStyleActive ? '100%' : '127px'}>
        <Flex flexDirection="column">
          <TextBoldWithNormal
            color={isNewWidgetStyleActive && theme.colors.deepLakeBlue[100]}
            lineHeight={isNewWidgetStyleActive && '16px!important'}
            fontSize={0}>
            {editCopyByReplaceWithMultipleComponent(COPY.LOYALTY_USER_COPY, loggedUserCopy)}
          </TextBoldWithNormal>
          <Text
            color={isNewWidgetStyleActive && theme.colors.deepLakeBlue[100]}
            lineHeight={isNewWidgetStyleActive && '16px!important'}
            fontSize={0}>
            {COPY.AVAILABLE}
          </Text>
        </Flex>
      </Box>
    </LoyaltyGenericContainer>
  ) : (
    <Text
      fontSize={`${isNewWidgetStyleActive ? theme.fontSizes[2] : theme.fontSizes[15]}px`}
      lineHeight={isNewWidgetStyleActive && '24px'}
      fontWeight={isNewWidgetStyleActive ? theme.fontWeights.medium : theme.fontWeights.bold}
      color={theme.colors.deepLakeBlue[100]}>
      {COPY.USER_COPY}
    </Text>
  );
};

LoyaltyAvailableMobileSearch.propTypes = {
  amount: PropTypes.number,
  isNewWidgetStyleActive: PropTypes.bool,
  showLoyalty: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool
};
LoyaltyAvailableMobileSearch.defaultProps = {
  amount: '0',
  isNewWidgetStyleActive: false,
  showLoyalty: false,
  isUserLoggedIn: false
};

const mapStateToProps = state => ({
  showLoyalty: showLoyalty(state),
  isUserLoggedIn: getUserIsLoggedIn(state.account)
});

export default connect(mapStateToProps)(LoyaltyAvailableMobileSearch);
